import { Component, Input, OnInit } from '@angular/core';
import { setTheme, Themes } from 'themes';
import { LandingpageConfiguration } from 'app/shared/models/landingpage-configuration.model';
import { HeaderComponent } from 'app/shared/components/header';
import { FooterComponent } from 'app/shared/components/footer';
import { ImageMetadata } from 'app/shared/models/image-metadata.model';

@Component({
  selector: 'ez-main-layout',
  imports: [HeaderComponent, FooterComponent],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
})
export class MainLayoutComponent implements OnInit {
  @Input() landingpageConfig: LandingpageConfiguration;
  @Input() theme: Themes = Themes.WHITELABEL;
  footerConfig: ImageMetadata;
  headerConfig: ImageMetadata;

  ngOnInit(): void {
    if (this.landingpageConfig) {
      this.footerConfig = this.landingpageConfig.layoutConfiguration.footer.image;
      this.headerConfig = this.landingpageConfig.layoutConfiguration.header.image;
    } else {
      this.footerConfig = {
        imgSrc: 'assets/icons/vb.svg',
        imgWidth: '',
        imgHeight: '',
      };
    }
    setTheme(this.theme);
  }
}
